import {actionMap} from '../reducers/index'
import querystring from 'querystring'
import moment from 'moment'
import {fetchApi} from 'shared/actions/fetchApi'
import * as types from './types'
import resetError from 'shared/errorHandler/actions/resetError'
import handleError from 'shared/errorHandler/actions/handleError'

export default (params) => dispatch => {
    dispatch({type: types.GET_DATA_START, params: params})
    dispatch(resetError())
    const flightDate = params.flightDate || moment().utc()
    let queryParams = querystring.stringify({
        begin: flightDate.startOf('day').format(),
        end: flightDate.endOf('day').format()
    })
    return fetchApi('/api/fs/schedule?' + queryParams)
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_DATA_SUCCESS, response: response, params: params
            })
        }).catch(error => {
            dispatch({
                type: types.GET_DATA_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading flights.'}))
        })
}

export const handler_GET_DATA_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: true,
        data: undefined
    })
}

export const handler_GET_DATA_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: action.response.Flights || []
    })
}

export const handler_GET_DATA_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.GET_DATA_START] = handler_GET_DATA_START
actionMap[types.GET_DATA_SUCCESS] = handler_GET_DATA_SUCCESS
actionMap[types.GET_DATA_FAILURE] = handler_GET_DATA_FAILURE



// WEBPACK FOOTER //
// ./src/screens/flights/actions/getData.js